export const recordTierOptions = [
  {
    displayName: 'none',
    id: 'none',
    label: 'none'
  },
  {
    displayName: 'Trial',
    id: 'trial',
    label: 'Trial'
  },
  {
    displayName: 'Sandbox',
    id: 'sandbox',
    label: 'Sandbox'
  },
  {
    displayName: 'Legacy',
    id: 'legacy',
    label: 'Legacy'
  },
  {
    displayName: '100',
    id: '100',
    label: '100'
  },
  {
    displayName: '250',
    id: '250',
    label: '250'
  },
  {
    displayName: '500',
    id: '500',
    label: '500'
  },
  {
    displayName: '1000',
    id: '1000',
    label: '1000'
  },
  {
    displayName: '2000',
    id: '2000',
    label: '2000'
  },
  {
    displayName: '2500',
    id: '2500',
    label: '2500'
  },
  {
    displayName: 'Custom',
    id: 'custom',
    label: 'Custom'
  }
];
